import React from "react";
import { joblist } from "../../utils/JobListDB";
import { formatSalaryString } from "../../utils/formatSalaryString";
import { Link } from "react-router-dom";

// Fallback data
const jobs = joblist || [];

// Individual Job Card
const JobCard = ({ job }) => (
  <Link
    to="/sign-up"
    className="
      tw-bg-white 
      tw-border tw-border-gray-200 
      tw-rounded-lg 
      tw-shadow-sm 
      tw-px-3 tw-pt-[10px] 
      tw-box-border 
      tw-flex-shrink-0 
      tw-w-[280px] sm:tw-w-[300px] md:tw-w-[400px] lg:tw-w-[520px] 
      hover:tw-shadow-md 
      tw-transition-shadow tw-duration-200 
      tw-mb-4 lg:tw-mb-0 
      sm:tw-mr-4
      lg:tw-mr-6
      tw-mb-4      
    "
    style={{ display: "block" }}
  >
    <div className="tw-flex tw-items-stretch tw-gap-4">
      {/* Company Logo */}
      <div
        className="tw-bg-[#E1F1F3] tw-rounded-lg tw-w-[65px] md:tw-w-[89px] tw-flex tw-items-start tw-justify-center"
        style={{ height: "135px" }}
      >
        <img
          src={job.thumbnail}
          alt={job.company}
          className="tw-w-[65px] md:tw-w-[89px] tw-h-[60px] md:tw-h-[80px] tw-object-contain"
        />
      </div>

      {/* Job Info */}
      <div className="tw-flex-1 tw-flex tw-flex-col tw-justify-center tw-min-w-0 tw-gap-[15px]">
        {/* Company + Date */}
        <div className="tw-text-[10px] sm:tw-text-[12px] tw-text-gray-500 tw-leading-[1.2]">
          {job.company} • {job.posted_at_str || "N/A"}
        </div>

        {/* Title */}
        <div className="tw-text-[13px] sm:tw-text-[16px] tw-font-semibold tw-leading-[1.3] tw-text-black tw-line-clamp-2">
          {job.title}
        </div>

        {/* Sector */}
        <div className="tw-text-[10px] sm:tw-text-[12px] tw-text-gray-500 tw-leading-[1.2]">
          {job.sector || "Industry N/A"}
        </div>

        {/* Metadata */}
        <div
          className="
  tw-grid 
  tw-grid-cols-2 
  lg:tw-flex 
  tw-gap-x-4 
  tw-text-[10px] sm:tw-text-[14px] 
  tw-leading-[1.2] 
  tw-text-gray-700 
  tw-border-b 
  tw-border-gray-200 
  tw-pb-[6px]
"
        >
          {job?.location && (
            <span
              className="tw-flex tw-items-center tw-gap-1 tw-truncate tw-px-1"
              title={job.location}
            >
              <i className="fa-solid fa-location-dot tw-flex-shrink-0"></i>
              <span className="tw-truncate">{job.location}</span>
            </span>
          )}
          <span className="tw-flex tw-items-center tw-gap-1 tw-truncate tw-px-1">
            <i className="fa-solid fa-briefcase tw-flex-shrink-0"></i>
            <span className="tw-truncate">
              {job?.work_from_home ? "Remote" : "On-Site"}
            </span>
          </span>
          <span
            className="tw-flex tw-items-center tw-gap-1 tw-truncate tw-px-1"
            title={job.schedule_type}
          >
            <i className="fa-solid fa-clock tw-flex-shrink-0"></i>
            <span className="tw-truncate">{job.schedule_type}</span>
          </span>
          {job?.salary && (
            <span
              className="tw-flex tw-items-center tw-gap-1 tw-truncate tw-px-1"
              title={formatSalaryString(job.salary)}
            >
              <i className="fa-solid fa-sack-dollar tw-flex-shrink-0"></i>
              <span className="tw-truncate">
                {formatSalaryString(job.salary)}
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  </Link>
);

// Job Slider
const JobSlider = () => {
  const first25 = jobs.slice(0, 25);
  const last25 = jobs.slice(-25);

  return (
    <div className="tw-relative tw-z-10 tw-mt-[80px]">
      {/* <h2 className="tw-text-[33px] sm:tw-text-[33px] tw-font-bold tw-mb-6 tw-text-center">
        Jobs & Internships that Match Your Story
      </h2> */}

      {/* Row 1 - scroll left */}
      <div className="tw-overflow-hidden">
        <div className="tw-flex tw-w-[200%] tw-animate-scrollLeft">
          {[...first25, ...first25].map((job, idx) => (
            <JobCard key={`row1-${idx}`} job={job} />
          ))}
        </div>
      </div>

      {/* Row 2 - scroll right */}
      <div className="tw-overflow-hidden tw-mt-6">
        <div className="tw-flex tw-w-[200%] tw-animate-scrollRight">
          {[...last25, ...last25].map((job, idx) => (
            <JobCard key={`row2-${idx}`} job={job} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobSlider;
